import { render, staticRenderFns } from "./DepositItemTab.vue?vue&type=template&id=e0db2c8a"
import script from "./DepositItemTab.vue?vue&type=script&lang=js"
export * from "./DepositItemTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports